import { CommonModule } from '@angular/common';
import { Inject, InjectionToken, Injector, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  _createStoreReducers, _INITIAL_REDUCERS, _INITIAL_STATE, _initialStateFactory,
  _REDUCER_FACTORY, _STORE_REDUCERS, ActionsSubject, combineReducers,
  createReducerFactory, INITIAL_REDUCERS, INITIAL_STATE, META_REDUCERS,
  REDUCER_FACTORY, ReducerManager, ReducerManagerDispatcher, ReducerObservable,
  ScannedActionsSubject, State, StateObservable, Store, StoreModule,
} from '@ngrx/store';
import {
  FakeMissingTranslationHandler, MissingTranslationHandler, TranslateCompiler,
  TranslateDefaultParser, TranslateFakeCompiler, TranslateFakeLoader,
  TranslateLoader, TranslateModule, TranslateParser, TranslateService,
  TranslateStore, USE_DEFAULT_LANG, USE_STORE
} from '@ngx-translate/core';
import { GeoWrapperComponent } from '../geo/geo-wrapper.component';
import { LocalizationComponent } from '../shared/components/localization.component';
import { CustomLoader } from '../shared/translate/custom-loader.class';
import * as fromRouter from '@ngrx/router-store';
import { geoReducer } from '../geo/geo.reducer';
import { targetingReducer } from '../targeting/targeting.reducer';

@NgModule({
  imports:         [
    StoreModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  providers:       [
    {provide: TranslateLoader, useClass: TranslateFakeLoader},
    {
      provide:  TranslateLoader,
      useClass: CustomLoader
    },
    {provide: TranslateCompiler, useClass: TranslateFakeCompiler},
    {provide: TranslateParser, useClass: TranslateDefaultParser},
    {
      provide:  MissingTranslationHandler,
      useClass: FakeMissingTranslationHandler
    },
    {provide: USE_STORE, useValue: {}},
    {
      provide:  USE_DEFAULT_LANG,
      useValue: LocalizationComponent.DEFAULT_LANGUAGE
    },
    TranslateStore,
    TranslateService,
    {provide: _INITIAL_STATE, useValue: {}},
    {
      provide:    INITIAL_STATE,
      useFactory: _initialStateFactory,
      deps:       [_INITIAL_STATE]
    },
    {
      provide:  _INITIAL_REDUCERS,
      useValue: Object.assign({}, {
        router: fromRouter.routerReducer,
      }, {
        geo:       geoReducer,
        targeting: targetingReducer
      })
    },
    {
      provide:     _STORE_REDUCERS,
      useExisting: Object.assign({}, {
            router: fromRouter.routerReducer,
          }, {
            geo: geoReducer,
            targeting: targetingReducer
          }) instanceof InjectionToken ? Object.assign({}, {
                router: fromRouter.routerReducer,
              }, {
                geo: geoReducer,
                targeting: targetingReducer
              }) : _INITIAL_REDUCERS
    },
    {
      provide:    INITIAL_REDUCERS,
      deps:       [Injector, _INITIAL_REDUCERS, [new Inject(_STORE_REDUCERS)]],
      useFactory: _createStoreReducers
    },
    {
      provide:  META_REDUCERS,
      useValue: []
    },
    {
      provide:  _REDUCER_FACTORY,
      useValue: combineReducers
    },
    {
      provide:    REDUCER_FACTORY,
      deps:       [_REDUCER_FACTORY, META_REDUCERS],
      useFactory: createReducerFactory,
    },
    State,
    {provide: StateObservable, useExisting: State},
    Store,
    ScannedActionsSubject,
    ReducerManager,
    {provide: ReducerObservable, useExisting: ReducerManager},
    {provide: ReducerManagerDispatcher, useExisting: ActionsSubject},
    ActionsSubject
  ],
  exports:         [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule
  ]
})

export class CoreModule {
  constructor (private translateService: TranslateService) {
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translateService.setDefaultLang(LocalizationComponent.DEFAULT_LANGUAGE);
    this.translateService.use(LocalizationComponent.DEFAULT_LANGUAGE);
  }
}
